// A page's first data request, started when the app boots instead of after the page's own code
// has downloaded. The page takes the response once (takeEarlyResponse); anything not taken
// within a minute is dropped, and every later request (retries, client navigation) fetches
// normally.
import { blogApiUrl } from './blogApi';
import { dealDataUrl } from './serviceUrls';

const EARLY_TTL_MS = 60_000;
const early = new Map();

const fetchJson = (url) => fetch(url, { headers: { Accept: 'application/json' } });

export function earlyRequestsFor(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '');
  const post = /^\/posts\/([^/]+)$/.exec(path);
  if (post) return [blogApiUrl(`/blog/posts/${encodeURIComponent(decodeURIComponent(post[1]))}`)];
  if (path === '/tools/qfwine') return [dealDataUrl('CurrentWine.json'), dealDataUrl('BestDealsEver.json')];
  if (path === '/tools/qfmarketplace') return [dealDataUrl('CurrentMarketplace.json'), dealDataUrl('BestDealsEverMarketplace.json')];
  return [];
}

export function startEarlyData(pathname = typeof window === 'undefined' ? '' : window.location.pathname) {
  for (const url of earlyRequestsFor(pathname)) {
    if (early.has(url)) continue;
    const response = fetchJson(url);
    response.catch(() => {});
    early.set(url, { response, at: Date.now() });
  }
}

/** The early response for this URL, once, or a fresh fetch. */
export function takeEarlyResponse(url, init) {
  const entry = early.get(url);
  if (entry) {
    early.delete(url);
    if (Date.now() - entry.at < EARLY_TTL_MS) return entry.response;
  }
  return init ? fetch(url, init) : fetch(url);
}
